import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <path d="M33.4,91.2c-2.2-5.1-10-6.5-17.4-3.2S4.4,98,6.6,103.1s10.1,6.4,17.5,3.1S35.6,96.2,33.4,91.2ZM30.9,95c-.8,1.1-3.4,3.8-8.9,7.1s-11.5,4.5-13.8,1.3c0,0-1.3-2.1,1.3-5.3s13.4-8.8,16.6-9.3,4.5,0,5.5,1.7S31.7,93.8,30.9,95Z" />
                <rect x="32.1" y="21.2" width="1.9" height="71.82" />
                <circle cx="48" cy="95" r="4" />
            </g>
        </svg>
    );
}
